import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useNavigate } from 'js/hooks/navigate';

export const useLegacyCoreNavigateListener = () => {
    const navigate = useNavigate();

    useEffect(() => {
        dispatcher.listen('core:navigate', navigate);

        return () => {
            dispatcher.removeListener('core:navigate', navigate);
        };
    }, [navigate]);
};
